/**
 * ★★ Feriado sem meta (02/11/2026) — DE ONDE SAI A LISTA DE FERIADOS. Puro.
 *
 * ★ Uma fonte só: o bloqueio de DIA INTEIRO da agenda de avaliação, marcado pelo gestor com a
 * caixinha "Feriado: sem meta para a equipe" (`docs/feriado-meta-plano.md` §1):
 *
 *   config.agendaAvaliacao.excecoes['AAAA-MM-DD'] = { horarios: [], motivo, semMeta: true }
 *
 * ⚠⚠ Três recusas, e cada uma é decisão do dono:
 *   - **faixa de horas nunca é feriado** (D2): o bloqueio por faixa grava `{ bloqueios }` SEM
 *     `horarios`, e meio dia mantém a meta inteira;
 *   - **`semMeta` só vale como booleano `true`**: `"true"` em texto não conta. Dado escrito à
 *     mão, pela metade, não pode tirar a meta de ninguém;
 *   - **lista crua e dia com horários próprios** não são dia fechado, então não são feriado.
 *
 * ★ Bloqueio sem a marca continua só fechando a agenda (D1): dentista de férias não é feriado.
 */

const DATA = /^\d{4}-\d{2}-\d{2}$/;

/** O dia inteiro fechado: objeto (não lista crua) com `horarios` vazio. */
export function ehDiaInteiro(excecao) {
  return Boolean(excecao) && typeof excecao === 'object' && !Array.isArray(excecao)
    && Array.isArray(excecao.horarios) && excecao.horarios.length === 0;
}

/** ★ O bloqueio que é feriado: dia inteiro E `semMeta === true`, estrito. */
export const ehBloqueioDeFeriado = (excecao) => ehDiaInteiro(excecao) && excecao.semMeta === true;

/**
 * Os feriados da clínica, em ordem: `['2026-10-12', '2026-11-02']`.
 *
 * @param config o `config` do documento da clínica (`clinica.config`)
 */
export function feriadosDaClinica(config) {
  const excecoes = config?.agendaAvaliacao?.excecoes;
  if (!excecoes || typeof excecoes !== 'object' || Array.isArray(excecoes)) return [];
  return Object.keys(excecoes)
    .filter((dia) => DATA.test(dia) && ehBloqueioDeFeriado(excecoes[dia]))
    .sort();
}

/** O dia é feriado? `dia` em 'AAAA-MM-DD'. Lista ausente ou lixo = nenhum feriado. */
export const ehFeriado = (dia, feriados = []) => Array.isArray(feriados) && feriados.includes(dia);
